export const invalidMsg = {
    image:'Supported image extensions are PNG, JPG/JPEG, GIF and BMP.',
    video:'Supported video extensions are  MP4, MPG, MPEG, MOV, AVI, WMV, WEBM, OGG and Quicktime.',
    doc:'Only PDF is supported extension for documents.'
}

export const getFileUuid = item =>{
    if(!item){
        return null;
    }
    if(typeof item.uuid == 'string' && item.uuid != ''){
        return item.uuid;
    }
    if(typeof item.file == 'string' && item.file != ''){
        return item.file;
    }
    if(typeof item.attachment_id == 'string' && item.attachment_id != ''){
        return item.attachment_id;
    }
    if(typeof item.id == 'string' && item.id != ''){
        return item.id;
    }   
}

const allowedExtensions = {
    video:[
        'video/mp4',
        'video/mpg',
        'video/mpeg',
        'video/mov',
        'video/avi',
        'video/wmv',
        'video/webm',
        'video/ogg',
        'video/quicktime',
    ],
    image:[
        'image/png', 
        'image/jpg', 
        'image/jpeg', 
        'image/gif', 
        'image/bmp', 
    ],
    doc: ['pdf']
};

export const validateFileType = (ext, type) => {
    const types = allowedExtensions[type];
    let valid = false;
    types.map(type => {
        if(type.includes(ext) || ext.includes(type)){
            valid = true;
        }
    });
    return valid;
}